// Vuex client module main file
import project from './project';
import projects from './projects';
import agents from './agents';
import groups from './groups';

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  modules: {
    project,
    projects,
    agents,
    groups,
  },
};

export default Module;
